import React, { useState } from "react";
import styled from "styled-components";
import Caret from "assets/icons/chevron2.svg";
import { ArrowWrapper } from "./SidebarStyle";

const Wrapper = styled.div`
  .dropdown-head {
    padding: 0 12px;
    display: flex;
    align-items: center;
    text-transform: uppercase;
    font-weight: 450;
    font-size: 12px;
    gap: 8px;
    margin-bottom: 8px;
    letter-spacing: 1px;

    &:hover {
      cursor: pointer;
    }

    .caret {
      transform: rotate(270deg);
      transition: var(--transition_default);
    }

    .rotate {
      transform: rotate(360deg);
    }
  }

  .dropdown-content {
    height: 0px;
    opacity: 0;
    pointer-events: none;
    transition: var(--transition_default);

    &.show {
      height: ${props => props.childrenCount * 40}px;
      opacity: 1;
      pointer-events: all;
    }
  }
`;

const DropDownLink = (props) => {
  const [showDropdownContent, setShowDropdownContent] = useState(true);
  return (
    <Wrapper childrenCount={props.children.length}>
      <div className="dropdown-head" onClick={()=> setShowDropdownContent(!showDropdownContent)}>
        <ArrowWrapper>
          <img
            src={Caret}
            alt="caret"
            className={`caret${showDropdownContent ? " rotate" : ""}`}
          />
        </ArrowWrapper>
        {props.title}
      </div>
      <div className={`dropdown-content${showDropdownContent ? " show" : ""}`}>{props.children}</div>
    </Wrapper>
  );
};

export default DropDownLink;
